require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-apprenticeships-the-time-tested-model-changing-the-face-of-tech.json") })
        }
      }, "path---blog-apprenticeships-the-time-tested-model-changing-the-face-of-tech");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-apprenticeships-the-time-tested-model-changing-the-face-of-tech!./.cache/json/blog-apprenticeships-the-time-tested-model-changing-the-face-of-tech.json
// module id = 596
// module chunks = 231608221292675